<template>
  <div class="shop-cart">
    <Breadcrumb />

    <div class="shop-table">
      <!-- 标题 -->
      <el-row :gutter="10">
        <el-col :span="4"> 我的购物车 </el-col>
        <el-col :span="14" :offset="6">
          <el-steps :active="active" align-center class="step">
            <el-step title="查看购物车"></el-step>
            <el-step title="确认订单信息"></el-step>
            <el-step title="完成支付"></el-step>
          </el-steps>
        </el-col>
      </el-row>

      <!-- 无数据 -->
      <div
        class="empty-cart"
        v-if="
          tableData.length <= 0 &&
            tableDataFlb.length <= 0 &&
            tableData3.length <= 0 &&
            tableData4.length <= 0 &&
            tableData5.length <= 0 &&
            tableData6.length <= 0 &&
            tableData7.length <= 0 &&
            tableData8.length <= 0 &&
            tableData9.length <= 0 &&
            tableData10.length <= 0 &&
            tableData11.length <= 0 &&
            tableData12.length <= 0 &&
            tableData13.length <= 0 &&
            tableData14.length <= 0 &&
            tableData15.length <= 0 &&
            tableData16.length <= 0 &&
            tableData17.length <= 0 &&
            tableData18.length <= 0 &&
            tableData19.length <= 0 &&
            tableData20.length <= 0 &&
            tableData21.length <= 0 &&
            tableData22.length <= 0 &&
            tableData23.length <= 0 &&
            tableData24.length <= 0 &&
            tableData25.length <= 0 &&
            tableData26.length <= 0 &&
            tableData27.length <= 0 &&
            tableData28.length <= 0 &&
            tableData29.length <= 0 &&
            tableData30.length <= 0 &&
            tableData31.length <= 0 &&
            tableData32.length <= 0 &&
            tableData33.length <= 0 &&
            tableData34.length <= 0 &&
            tableData35.length <= 0 &&
            tableData36.length <= 0 &&
            tableData37.length <= 0 &&
            tableData38.length <= 0 &&
            tableData39.length <= 0 &&
            tableData40.length <= 0
        "
      >
        <div class="e_icon_content">
          <i
            style="font-size:39px;color: #4934b2;margin-right: 17px;"
            class="el-icon-shopping-cart-1"
          ></i>
          <span style="font-size: 20px"> 购物车空空如也,赶紧去 </span>
          <router-link to="/select/custom/list" class="r_link">
            <span style="font-size: 20px; color: #4934b2;"> 逛逛吧！ </span>
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="tableData.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["01"] }}
        </div>
      </div>
      <el-table :data="tableData" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableDataFlb.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["02"] }}
        </div>
      </div>
      <el-table :data="tableDataFlb" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData3.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["03"] }}
        </div>
      </div>
      <el-table :data="tableData3" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData4.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["04"] }}
        </div>
      </div>
      <el-table :data="tableData4" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData5.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["05"] }}
        </div>
      </div>
      <el-table :data="tableData5" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData6.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["06"] }}
        </div>
      </div>
      <el-table :data="tableData6" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData7.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["07"] }}
        </div>
      </div>
      <el-table :data="tableData7" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData8.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["08"] }}
        </div>
      </div>
      <el-table :data="tableData8" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData9.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["09"] }}
        </div>
      </div>
      <el-table :data="tableData9" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData10.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["10"] }}
        </div>
      </div>
      <el-table :data="tableData10" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableData11.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["11"] }}
        </div>
      </div>
      <el-table :data="tableData11" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableData12.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["12"] }}
        </div>
      </div>
      <el-table :data="tableData12" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableData13.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["13"] }}
        </div>
      </div>
      <el-table :data="tableData13" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableData14.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["14"] }}
        </div>
      </div>
      <el-table :data="tableData14" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableData15.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["15"] }}
        </div>
      </div>
      <el-table :data="tableData15" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableData16.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["16"] }}
        </div>
      </div>
      <el-table :data="tableData16" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData17.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["17"] }}
        </div>
      </div>
      <el-table :data="tableData17" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tableData18.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["18"] }}
        </div>
      </div>
      <el-table :data="tableData18" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

 
    <div v-if="tableData19.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["19"] }}
        </div>
      </div>
      <el-table :data="tableData19" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    
    <div v-if="tableData20.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["20"] }}
        </div>
      </div>
      <el-table :data="tableData20" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData21.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["21"] }}
        </div>
      </div>
      <el-table :data="tableData21" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData22.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["22"] }}
        </div>
      </div>
      <el-table :data="tableData22" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData23.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["23"] }}
        </div>
      </div>
      <el-table :data="tableData23" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData24.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["24"] }}
        </div>
      </div>
      <el-table :data="tableData24" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData25.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["25"] }}
        </div>
      </div>
      <el-table :data="tableData25" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData26.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["26"] }}
        </div>
      </div>
      <el-table :data="tableData26" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData27.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["27"] }}
        </div>
      </div>
      <el-table :data="tableData27" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData28.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["28"] }}
        </div>
      </div>
      <el-table :data="tableData28" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData29.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["29"] }}
        </div>
      </div>
      <el-table :data="tableData29" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData30.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["30"] }}
        </div>
      </div>
      <el-table :data="tableData30" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData31.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["31"] }}
        </div>
      </div>
      <el-table :data="tableData31" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData32.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["32"] }}
        </div>
      </div>
      <el-table :data="tableData32" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData33.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["33"] }}
        </div>
      </div>
      <el-table :data="tableData33" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData34.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["34"] }}
        </div>
      </div>
      <el-table :data="tableData34" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData35.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["35"] }}
        </div>
      </div>
      <el-table :data="tableData35" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData36.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["36"] }}
        </div>
      </div>
      <el-table :data="tableData36" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData37.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["37"] }}
        </div>
      </div>
      <el-table :data="tableData37" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData38.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["38"] }}
        </div>
      </div>
      <el-table :data="tableData38" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData39.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["39"] }}
        </div>
      </div>
      <el-table :data="tableData39" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div v-if="tableData40.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：{{ dictMap["MANUFACTURER"]["40"] }}
        </div>
      </div>
      <el-table :data="tableData40" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#4934b2' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="bottom-content bottom-sticky">
      <el-row type="flex" style="margin-bottom: 0px">
        <el-col :span="4">
          <el-checkbox
            v-model="ifCheckAll"
            :indeterminate="isIndeterminate"
            @change="checkAll"
            >全选</el-checkbox
          >
        </el-col>
        <el-col class="cart-info" :span="17">
          <span>
            共
            <span class="font-red">{{ proAmountTotal }}</span>
            件商品, 已选择
            <span class="font-red">{{ Number(checkCount) }}</span>
            件
          </span>
          <el-divider direction="vertical"></el-divider>
          <span> 合计（不含运费）： </span>
          <span class="large-price form-required">¥ {{ total }}</span>
        </el-col>
        <el-col class="pay-btn text-noSelect" :span="3">
          <div @click="settlement" class="settle-btn">下单</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {
  listCart,
  delCart,
  updateCart,
  updateCartCount,
  selectCart
} from '@/api/order/cart'
import { mapGetters } from "vuex"

export default {
    name: "shoppingCart",
    components:{
      Breadcrumb
    },
     computed: {
    ...mapGetters(["dictData", "dictMap", "token", "user"]),
  },
    data(){
      return {
        tableData: [],
        tableDataFlb: [],
        tableData3: [],
        tableData4: [],
        tableData5: [],
        tableData6: [],
        tableData7: [],
        tableData8: [],
        tableData9: [],
        tableData10: [],
        tableData11: [],
        tableData12: [],
        tableData13: [],
        tableData14: [],
        tableData15: [],
        tableData16: [],
        tableData17: [],
        tableData18: [],
        tableData19: [],
        tableData20: [],
        tableData21: [],
        tableData22: [],
        tableData23: [],
        tableData24: [],
        tableData25: [],
        tableData26: [],
        tableData27: [],
        tableData28: [],
        tableData29: [],
        tableData30: [],
        tableData31: [],
        tableData32: [],
        tableData33: [],
        tableData34: [],
        tableData35: [],
        tableData36: [],
        tableData37: [],
        tableData38: [],
        tableData39: [],
        tableData40: [],
        dataArray: [19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40],
        ifCheckAll: false,
        isIndeterminate: false,
        proAmountTotal: 0, // 商品总件数
        checkCount: 0, // 选中商品数
        total: 0, // 商品总价
        checkList: [], //选中的数据
        active: 1,
        isRefresh: false
      }
    },
    async mounted(){
      await this.loadData();

      this.ifCheckAll = true
      this.checkAll()
    },
    watch: {
      tableData() {
        this.$nextTick(() => {
          // this.tableData.length > 0 && this.$refs.shopCartTable.toggleAllSelection();
          this.calculate();
        })
      }
    },
    methods: {
      // 获取数据
     async  loadData() {
        this.startLoading()
        this.proAmountTotal = 0
        let res = await listCart()

        res.rows.forEach(row => {
          if(row.skuList){
            row.skuList.map(el => {
              if (row.skuId === el.skuId) {
                row['activeSku'] = el
              }
            })
            this.proAmountTotal += Number(row.productNum)
            row.checked = false;
          }

        });

        res.rows.map(record=>{
          for(let item of this.checkList){
            if(item.cartId == record.cartId){
              record.checked = true
              item.productNum = record.productNum
              item.totalPrice = record.totalPrice
              item.embroideryCost  = record.embroideryCost
              item.embroideryPrice  = record.embroideryPrice
            }
          }
        })
        this.tableData = res.rows.filter((record)=>{
          return record.manufacturer == '01'
        })

        this.tableDataFlb = res.rows.filter((record)=>{
          return record.manufacturer == '02'
        })

        this.tableData3 = res.rows.filter((record)=>{
          return record.manufacturer == '03'
        })


        this.tableData4 = res.rows.filter((record)=>{
          return record.manufacturer == '04'
        })


        this.tableData5 = res.rows.filter((record)=>{
          return record.manufacturer == '05'
        })


        this.tableData6 = res.rows.filter((record)=>{
          return record.manufacturer == '06'
        })

        this.tableData7 = res.rows.filter((record)=>{
          return record.manufacturer == '07'
        })

        this.tableData8 = res.rows.filter((record)=>{
          return record.manufacturer == '08'
        })

        this.tableData9 = res.rows.filter((record)=>{
          return record.manufacturer == '09'
        })

           this.tableData10 = res.rows.filter((record)=>{
          return record.manufacturer == '10'
        })
           this.tableData11 = res.rows.filter((record)=>{
          return record.manufacturer == '11'
        })
           this.tableData12 = res.rows.filter((record)=>{
          return record.manufacturer == '12'
        })
           this.tableData13 = res.rows.filter((record)=>{
          return record.manufacturer == '13'
        })
           this.tableData14 = res.rows.filter((record)=>{
          return record.manufacturer == '14'
        })
        this.tableData15 = res.rows.filter((record)=>{
          return record.manufacturer == '15'
        })
        this.tableData16 = res.rows.filter((record)=>{
          return record.manufacturer == '16'
        })

        this.tableData17 = res.rows.filter((record)=>{
          return record.manufacturer == '17'
        })

        this.tableData18 = res.rows.filter((record)=>{
          return record.manufacturer == '18'
        })

        this.tableData19 = res.rows.filter((record)=>{
          return record.manufacturer == '19'
        })

        
        this.tableData20 = res.rows.filter((record)=>{
          return record.manufacturer == '20'
        })
        
        this.tableData21 = res.rows.filter((record)=>{
          return record.manufacturer == '21'
        })
        
        this.tableData22 = res.rows.filter((record)=>{
          return record.manufacturer == '22'
        })
        
        this.tableData23 = res.rows.filter((record)=>{
          return record.manufacturer == '23'
        })
        
        this.tableData24 = res.rows.filter((record)=>{
          return record.manufacturer == '24'
        })
        
        this.tableData25 = res.rows.filter((record)=>{
          return record.manufacturer == '25'
        })
        
        this.tableData26 = res.rows.filter((record)=>{
          return record.manufacturer == '26'
        })
        
        this.tableData27 = res.rows.filter((record)=>{
          return record.manufacturer == '27'
        })
        
        this.tableData28 = res.rows.filter((record)=>{
          return record.manufacturer == '28'
        })
        
        this.tableData29 = res.rows.filter((record)=>{
          return record.manufacturer == '29'
        })
        
        this.tableData30 = res.rows.filter((record)=>{
          return record.manufacturer == '30'
        })
        
        this.tableData31 = res.rows.filter((record)=>{
          return record.manufacturer == '31'
        })
        
        this.tableData32 = res.rows.filter((record)=>{
          return record.manufacturer == '32'
        })
        
        this.tableData33 = res.rows.filter((record)=>{
          return record.manufacturer == '33'
        })
        
        this.tableData34 = res.rows.filter((record)=>{
          return record.manufacturer == '34'
        })
        
        this.tableData35 = res.rows.filter((record)=>{
          return record.manufacturer == '35'
        })
        
        this.tableData36 = res.rows.filter((record)=>{
          return record.manufacturer == '36'
        })
        
        this.tableData37 = res.rows.filter((record)=>{
          return record.manufacturer == '37'
        })
        
        this.tableData38 = res.rows.filter((record)=>{
          return record.manufacturer == '38'
        })
        
        this.tableData39 = res.rows.filter((record)=>{
          return record.manufacturer == '39'
        })
        
        this.tableData40 = res.rows.filter((record)=>{
          return record.manufacturer == '40'
        })



        this.calculate();
        this.endLoading();
      },
      changeProper(data, index, row, active) {
        let skuId = ''
        const properVal0 = active.properVal.split(':')[0]
        const properVal1 = active.properVal.split(':')[1]
        let newProperVal = ''

        if (index === 0) {
          newProperVal = data + ':' + properVal1
        }
        if (index === 1) {
          newProperVal = properVal0 + ':' + data
        }

        row.skuList.map(el => {
          if (el.properVal.replace(/\\/g, '') === newProperVal) {
            skuId = el.skuId
          }
        })

        updateCart({
          cartId: row.cartId,
          skuId: skuId
        }).then((res) => {
          if (res.code === 200) {
            this.loadData()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          this.$message.error(error.msg)
        });
      },
      // 删除商品
      removerRow(row) {
        this.$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCart(row.cartId).then(res => {
            if (res.code === 200) {
              this.$store.dispatch("GetIndexStat")
              this.$message.success('删除成功')
              //删除
              for(let i = 0;i< this.checkList.length;i++){
                if(this.checkList[i].cartId == row.cartId){
                  this.checkList.splice(i, 1)
                  break
                }
              }
              this.loadData()
            } else {
              this.$message.error(res.msg)
            }
          }).catch(error => {
            this.$message.error(error.msg)
          });
        });
      },
      // 下单结算
      settlement() {
        if (this.checkList.length == 0) {
          this.$message.info("您还没有选择商品哦")
        } else {
          const type = []
          let manufacturer = []
          this.checkList.map(el => {
            type.push(el.productType)
            manufacturer.push(el.manufacturer)
          })
          console.log('type ------------', this._.union(type))

          if (this._.union(type).length > 1) {
            this.$message.info("不同类型商品不可一起付款哦")
          } else if (this._.union(manufacturer).length > 1) {
            this.$message.info("不同生产厂商不可一起付款哦")
          }else {
            //判断数量
            let product = {}
            for(let record of this.checkList){
              if(!product[record.pId]){
                product[record.pId] = {
                  productNum: Number(record.productNum),
                  moq: record.moq,
                  proName: record.proName
                }
              } else{
                product[record.pId].productNum +=  Number(record.productNum)
              }
            }

            for(let record in product){
                if(product[record].productNum < product[record].moq){
                this.$message.info(`${product[record].proName}不能低于起订数量${product[record].moq}件`)
                return
              }
            }

            sessionStorage.setItem("settlement", JSON.stringify(this.checkList));

            this.$router.push({
              path: '/order/myOrder/settlement'
            })
          }
        }
      },
      // 选中所有行
      async checkAll(val) {
        this.isIndeterminate = false;

        let cartArray = []
        this.tableData.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: this.ifCheckAll ? '1' : '0'
          })
        })

        await selectCart(cartArray)

        await this.loadData()

        this.checkList = []

        let tables = [this.tableData,this.tableDataFlb,this.tableData3,this.tableData4,this.tableData5,this.tableData6,this.tableData7,
        this.tableData8,this.tableData9,this.tableData10,this.tableData11,this.tableData12,this.tableData13,this.tableData14,this.tableData15,this.tableData16,this.tableData17,this.tableData18,this.tableData19
        ,this.tableData20,this.tableData21,this.tableData22,this.tableData23,this.tableData24,this.tableData25,this.tableData26,this.tableData27,this.tableData28
        ,this.tableData29,this.tableData30,this.tableData31,this.tableData32,this.tableData33,this.tableData34,this.tableData35,this.tableData36,this.tableData37,this.tableData38,this.tableData39,this.tableData40]

        for(let data of tables){
          data.map(record=>{
            if(this.ifCheckAll && record.dzStatus == '01'){
              this.checkList.push(record)
            }
            record.checked = this.ifCheckAll && record.dzStatus == '01' ? true : false
          })
        }
        this.calculate()
      },
      // 更新数量
      getSubtotal(val, row) {
        updateCartCount({
          productNum: val,
          cartId: row.cartId,
          skuId: row.skuId
        }).then(res => {
          if (res.code === 200) {
            this.loadData()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          this.$message.error(error.msg)
        });
      },
      // 行勾选事件
      async handleSelectionChange(val) {
        this.startLoading()
        this.isIndeterminate = val.length > 0 && val.length < this.tableData.length;
        this.checkList = []
        let cartArray = []

        this.tableData.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

        this.tableDataFlb.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

         this.tableData3.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

         this.tableData4.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

         this.tableData5.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

         this.tableData6.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

         this.tableData7.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

         this.tableData8.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

         this.tableData9.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
         this.tableData10.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
         this.tableData11.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
         this.tableData12.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
         this.tableData13.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
         this.tableData14.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
         this.tableData15.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
         this.tableData16.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
        this.tableData17.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
        this.tableData18.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

          this.tableData19.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData20.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData21.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData22.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData23.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData24.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData25.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData26.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData27.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData28.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData29.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData30.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData31.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData32.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData33.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData34.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData35.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData36.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData37.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData38.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData39.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
          this.tableData40.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })
        
        await selectCart(cartArray)


        await this.loadData()

        this.calculate();
      },
      // 计算商品合计、实付金额
      calculate () {
        this.checkCount = 0
        this.total = 0;
        this.checkList.forEach(row =>{
          this.checkCount += Number(row.productNum)
          this.total += Number(row.totalPrice)
        });
        this.total =  Math.round(this.total * 100) / 100
      }
    },
}
</script>

<style scoped lang="scss">
.shop-cart {
  height: 100%;

  .shop-table {
    padding: 18px;
    border: 1px solid #ebeef5;
    background: #fff;
    font-size: 14px;
    overflow: hidden;
    color: #595a5a;

    .step {
      position: relative;
      right: -75px;
      top: 7px;
    }
  }

  .empty-img {
    width: 60px;
    height: 60px;
    margin-right: 20px;
  }
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-direction: column;

  .delete {
    color: #ccc;
    text-decoration: line-through;
  }
}
.product-type {
  position: absolute;
  left: 56px;
  top: 0;
  border-color: rgb(255, 144, 0);
  background-color: rgb(255, 144, 0);
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.tab-content {
  position: relative;
}
</style>
